<template>
  <nuttrema-layout-form-standard
     theme="global"
     class="is-no-center-scroll is-no-center-padding is-section-transparent"
    :edit="true">
    <template slot="center">

      <el-form
        ref="formData"
        label-width="25%"
        :rules="rules"
        :model="formData">

        <section>
          <h4 class="section-title">
            {{ $t('label.choose_your_subdomain_name') }}
            <nuttrema-overlay-youtube-button :file="$t('file.register_your_instance')" :anchor="$t('label.link_open_video_tutorial')"></nuttrema-overlay-youtube-button>
          </h4>

          <div class="section-items">
            <el-form-item
               prop="email"
              :label="$t('label.email')">
              <el-col :span="16" :xs="24">
                <el-input v-model="formData.email"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item
              prop="subdomain"
              :label="$t('label.instance_subdomain')">
              <el-col :span="16" :xs="24">
                <el-input
                   v-model="formData.subdomain"
                  :minlength="3"
                  :maxlength="63"
                  :placeholder="$t('label.instance_subdomain_placeholder')">
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item
               class="is-unset-line-height"
              :label="$t('label.instance_url')">
              <el-col :span="16" :xs="24">
                <el-input
                   :value="formData.subdomain ? $t('label.subdomain_example_url', { subdomain: formData.subdomain }) : ''"
                   :disabled="true">
                   <template slot="prepend">https://</template>
                </el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.preffered_language')">
              <el-col :span="16" :xs="24">
                <el-select v-model="formData.language_id" class="w-100" @change="handlePrefferedLanguageChange">
                  <el-option v-for="language in _get(SettingsLanguages, 'data', [])"
                    :label="language.native_name"
                    :value="language.id"
                    :key="language.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-row type="flex" style="margin: 1em 0 1.5em 25%">
              <el-col :span="16" :xs="24">
                <p class="section-help is-padding-small is-center">
                  <el-popover
                   ref="popover1"
                   placement="top"
                   trigger="hover"
                   width="380"
                   popper-class="el-popover--options"
                  :title="$t('label.instance_subdomain_rule_00')"
                  :open-delay="500">
                  <div class="el-popover__content">
                    <p>{{ $t('label.instance_subdomain_rule_01') }}</p>
                    <ul>
                      <li>{{ $t('label.instance_subdomain_rule_02') }}</li>
                      <li>{{ $t('label.instance_subdomain_rule_03') }}</li>
                      <li>{{ $t('label.instance_subdomain_rule_04') }}</li>
                      <li>{{ $t('label.instance_subdomain_rule_05') }}</li>
                      <li>{{ $t('label.instance_subdomain_rule_06') }}</li>
                      <li>{{ $t('label.instance_subdomain_rule_07') }}</li>
                    </ul>
                  </div>
                  </el-popover>
                  <el-button size="mini" type="text" v-popover:popover1>{{ $t('label.instance_subdomain_rule_00') }}</el-button>
                </p>
              </el-col>
            </el-row>

            <el-form-item v-if="showMessage && checked">
              <el-col :span="16" :xs="24">

                <nuttrema-notification
                   v-if="canProceedToNextStep"
                   theme="success"
                  :closable="false"
                  :title="$t(`label.${messageCode}`)">
                </nuttrema-notification>

                <nuttrema-notification
                   v-else
                   theme="info"
                  :closable="false"
                  :title="$t(`label.${messageCode}`)">
                </nuttrema-notification>

              </el-col>
            </el-form-item>

            <el-form-item>
              <el-col :span="16":xs="24">

                <el-button
                   v-if="canProceedToNextStep"
                   type="nuttrema-orange"
                   class="w-100 is-icon-ml-100"
                  @click="nextStep">
                  {{ $t('label.proceed_to_next_step') }}<i class="far fa-chevron-right"></i>
                </el-button>

                <el-button
                   v-else
                   type="nuttrema-dark-gray"
                   class="w-100"
                  @click="checkSubdomainAndEmailAvailability">
                  {{ $t('label.check_availability') }}
                </el-button>

              </el-col>
            </el-form-item>

          </div>

          <el-row type="flex" style="margin: 0.5em 0">
            <el-col :span="24" :xs="24">
              <p class="section-help is-padding-small" v-html="_markdown.render($t('label.instance_registration_help'))"></p>
            </el-col>
          </el-row>

          <div class="section-help" style="margin-top: 2em">
            <el-row>
              <el-col :xs="24" :md="24" style="text-align: center">
                <router-link
                   class="el-button el-button--text"
                  :to="{ name: 'professional-login' }">
                  {{ $t('label.i_have_registed_account') }}
                </router-link>

              <el-col :xs="24" :md="24" style="text-align: center">
                <router-link
                   class="el-button el-button--text"
                  :to="{ name: 'professional-resend-completion-token' }">
                  {{ $t('label.purchase_confirmation_email_not_arrive') }}
                </router-link>
              </el-col>
              </el-col>
            </el-row>
          </div>
        </section>

      </el-form>

    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { get, has, find, includes } from 'lodash';

import { mapGetters } from 'vuex';
import moment from 'moment';

import { REGISTRATION_STATUS } from 'constants/values';

import { checkRestrictedSubdomain } from 'helpers/validation-helper';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';
import NuttremaNotification from 'components/ui/alert/nuttrema-notification';

import NuttremaOverlayYoutubeButton from 'components/ui/overlay/nuttrema-overlay-youtube-button';

export default {
  name: 'cmpt-choose-instance-name',
  componentName: 'CmptChooseInstanceName',
  components: {
    NuttremaFormAlert,
    NuttremaNotification,
    NuttremaLayoutFormStandard,
    NuttremaOverlayYoutubeButton,
  },
  mixins: [FormStandardBehavior],
  props: {
    email: {
      required: false,
      default: null,
    },
    lang: {
      required: false,
      default: null,
    },
    SubdomainAndEmailAvailability: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      context: 'login context',
      checked: false,
      formData: {
        email: null,
        subdomain: null,
        language_id: null,
      },
      rules: {
        email: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.email', true),
          },
          { type: 'email',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
          },
        ],
        subdomain: [
          {
            required: true,
            message: this.formatValidationMessage('validation.required', 'label.instance_subdomain', true),
            trigger: 'blur',
          },
          {
            min: 3,
            max: 63,
            message: this.formatValidationMessage('validation.instance_subdomain_lenght'),
            trigger: 'blur',
          },
          {
            validator: this.validateSubdomain,
            message: this.formatValidationMessage('validation.invalid', 'label.instance_subdomain', true),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    validateSubdomain(rule, value, callback) {
      if (!checkRestrictedSubdomain(value)) return callback(new Error());
      return callback();
    },
    checkSubdomainAndEmailAvailability() {
      console.log('start checking');
      this.checked = false;

      this.$refs.formData.validate((valid) => {
        console.log(valid);
        if (valid) this.$emit('checkSubdomainAndEmailAvailability', this.formData);
      });
    },
    nextStep() {
      this.$emit('proceedRegistration', this.formData);
    },
    handlePrefferedLanguageChange(id) {
      const languages = get(this.SettingsLanguages, 'data', []);
      const preffered = find(languages, { id });
      if (preffered) this.$locale.change(preffered.code);
    },
    setCurrentLanguageFromPrefference(code) {
      const prefferedCode = code || this.$locale.current();
      const currentLanguage = find(get(this.SettingsLanguages, 'data', []), language => language.code === prefferedCode);
      this.formData.language_id = get(currentLanguage, 'id');
      if (prefferedCode !== this.$locale.current()) this.$locale.change(prefferedCode);
    },
  },
  computed: {
    ...mapGetters([
      'SettingsLanguages',
    ]),
    canProceedToNextStep() {
      const registrationStatus = get(this.SubdomainAndEmailAvailability, 'data.code');
      const next = includes(REGISTRATION_STATUS.AVAILABLE, registrationStatus);
      return next && this.checked;
    },
    showMessage() {
      return has(this.SubdomainAndEmailAvailability, 'data.ok') && this.checked;
    },
    messageCode() {
      const lastUpdate = get(this.SubdomainAndEmailAvailability, 'data.last_update');
      let code = get(this.SubdomainAndEmailAvailability, 'data.code', '');

      if (lastUpdate) {
        const now = moment.utc();
        const to = moment(lastUpdate);
        const min = now.diff(to, 'minutes');
        console.log('last update', now, to, min);
        if (min >= 180) code = 'instance_registration_new';
      }

      return code;
    },
    currentLanguage() {
      this.setCurrentLanguageFromPrefference();
      return this.$locale.current();
    },
  },
  watch: {
    'formData.email': {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) this.checked = false;
      },
      deep: true,
    },
    'formData.subdomain': {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) this.checked = false;
      },
      deep: true,
    },
  },
  created() {
    this.formData.email = this.email;

    this.setCurrentLanguageFromPrefference(this.lang);

    this.$on('checked', () => {
      this.checked = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-choose-instance-name.vue